import { animate, stagger } from "motion";
import "./home.css";

document.addEventListener("DOMContentLoaded", async () => {
  const grid = document.querySelector(".header-image-grid");

  if (!grid || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  await animate([
    [
      Array.from(grid.querySelectorAll(".grid-item")).sort(() => Math.random() - 0.5),
      {
        opacity: [0, 1],
        scale: [0.9, 1],
      },
      {
        duration: 0.5,
        delay: stagger(0.1),
        ease: "easeInOut",
      },
    ],
  ]).finished;

  const headerImageJson = document.getElementById("header-image-json");
  const headerImages = JSON.parse(headerImageJson.textContent);
  let availableImages = [...headerImages];
  let intervalId;
  let isAnimating = false;

  const run = async () => {
    if (isAnimating || document.hidden) return;
    isAnimating = true;

    const gridItems = Array.from(grid.querySelectorAll(".grid-item")).sort(() => Math.random() - 0.5);

    const promises = gridItems.map(async (item, index) => {
      await new Promise((resolve) => setTimeout(resolve, index * 100));

      await animate(
        item,
        {
          opacity: [1, 0],
          scale: [1, 0.9],
        },
        {
          duration: 0.3,
          ease: "easeInOut",
        },
      ).finished;

      const img = item.querySelector("img");

      if (img && availableImages.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableImages.length);
        const newImageUrl = availableImages[randomIndex];

        availableImages.splice(randomIndex, 1);
        img.src = newImageUrl;

        if (availableImages.length === 0) {
          availableImages = [...headerImages];
        }
      }

      await animate(
        item,
        {
          opacity: [0, 1],
          scale: [0.9, 1],
        },
        {
          duration: 0.5,
          ease: "easeInOut",
        },
      ).finished;
    });

    await Promise.all(promises);

    isAnimating = false;
  };

  const startInterval = () => {
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      if (!document.hidden) {
        run();
      }
    }, 5000);
  };

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      clearInterval(intervalId);
    } else {
      const gridItems = grid.querySelectorAll(".grid-item");

      gridItems.forEach((item) => {
        item.style.opacity = "1";
        item.style.transform = "scale(1)";
      });

      isAnimating = false;

      startInterval();
    }
  });

  setTimeout(() => {
    run();
    startInterval();
  }, 2000);
});
